var _rect, _defs, _title, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadarPaused(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184,
    height: 180,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 78.27864074707031,
    cy: 65.99895477294922,
    r: 65.93020629882812
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.3%",
    y: "-15.5%",
    width: "132.6%",
    height: "132.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745098   0 0 0 0 0.137254902   0 0 0 0 0.443137255  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "10.5992166%",
    fx: "50%",
    fy: "10.5992166%",
    r: "110.727395%",
    gradientTransform: "translate(0.500000,0.105992),scale(0.997077,1.000000),rotate(53.842225),translate(-0.500000,-0.105992)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCB11",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCB11",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WF-SaaS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clawdia_privacy-policy-scaner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3BAFF",
    fillRule: "nonzero",
    cx: 91.6410064544917,
    cy: 90.22088470619363,
    r: 83.47416324380265
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D5E0FF",
    fillRule: "nonzero",
    cx: 91.39575624634105,
    cy: 90.22088470619363,
    r: 62.60562464125269
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3BAFF",
    fillRule: "nonzero",
    cx: 91.39575624634105,
    cy: 90.22088470619363,
    r: 41.737081621901325
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#111C5B",
    fillRule: "nonzero",
    cx: 91.39575624634105,
    cy: 90.22088470619363,
    r: 20.868540810950662
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39575026141056,173.69504831684242 L91.64328113209,90.64139035294353 C60.55824135056355,90.64139035294353 32.33350921224058,90.58181728277354 6.969084884075627,90.46267130702643 C6.969084884075627,136.4306433561603 44.768190505643545,173.69504831684242 91.39575026141056,173.69504831684242 z",
    id: "Oval",
    fill: "url(#radialGradient-3)",
    fillRule: "nonzero",
    transform: ""
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarPaused);
export default __webpack_public_path__ + "static/media/radar-paused.c5c4b76052bc9091ca3141c8b3e5c6e2.svg";
export { ForwardRef as ReactComponent };